export const TERMS_LIBRARIES_RESET_STATE = 'TERMS_LIBRARIES_RESET_STATE';
export const TERMS_LIBRARIES_CURRENT_ITEM = 'TERMS_LIBRARIES_CURRENT_ITEM';

export const TERMS_LIBRARIES_REQUEST_LOADING = 'TERMS_LIBRARIES_REQUEST_LOADING';
export const TERMS_LIBRARIES_REQUEST_SUCCESS = 'TERMS_LIBRARIES_REQUEST_SUCCESS';
export const TERMS_LIBRARIES_REQUEST_FAILED = 'TERMS_LIBRARIES_REQUEST_FAILED';

export const TERMS_LIBRARIES_CURRENT_ACTION = 'TERMS_LIBRARIES_CURRENT_ACTION';
export const TERMS_LIBRARIES_RESET_ACTION = 'TERMS_LIBRARIES_RESET_ACTION';